import { put, takeLatest } from 'redux-saga/effects';
import actions from '../actions';
import { getServiceProvider, IAuthService, IServiceProvider } from '../../../services';
import { commonActions } from '../../common';

const updateAuthorities = takeLatest(
  commonActions.signIn.success.type,
  function* () {
    const serviceProvider: IServiceProvider = yield getServiceProvider();
    const authService: IAuthService = yield serviceProvider.getAuthService();
    const authorities: string[] = yield authService.getAuthorities();
    yield put(actions.setAuthorities({ authorities }));
  }
);

const reloadAuthoritiesSaga = takeLatest(
  commonActions.updateAuthorities.type,
  function* () {
    const serviceProvider: IServiceProvider = yield getServiceProvider();
    const authService: IAuthService = yield serviceProvider.getAuthService();
    const permissions: string[] = yield authService.getAuthorities(true);
    yield put(actions.setAuthorities({ authorities: permissions }));
  }
);

const sagas = [updateAuthorities, reloadAuthoritiesSaga];

export default sagas;
